export const enums = {
  ROLES: {
    super_admin: "super_admin",
    ent_admin: "enterprise",
    org_admin: "organization",
    user: "user",
  },
};
